var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('String',{staticClass:"string--warm-white",attrs:{"strLength":this.strLength}},[_c('WarmWhiteLED',{attrs:{"brightness":_vm.channelOneBrightness}}),_c('WarmWhiteLED',{attrs:{"brightness":_vm.channelTwoBrightness}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }